import i18n from 'i18next';

import { BenefitType } from '@epi-constants/benefitTypes';

export const getFrequencyLabel = (benefitType: string) => {
  return benefitType.toLowerCase() === BenefitType.Lunch
    ? i18n.t('containers.beneficiaries.detail.benefit_section.daily')
    : i18n.t('containers.beneficiaries.detail.benefit_section.yearly');
};
